<!--
 * @Author: your name
 * @Date: 2019-11-12 15:57:59
 * @LastEditTime: 2019-11-14 18:16:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\mainMap\UCOverlay\DrawPolycurveOverlay.vue
 -->
<!--  -->
<template>

  <div class="tdt_popup_content">
    <div
      class="info_container"
      popupshow="true"
    >
      <div class="info_box">
        <div class="title"><span>{{titleName}}</span>

          <div
            class="add_collect_box"
            style="margin-left: 10px; margin-top: 3px;"
            id="id_addCollectItem"
          ><i
              title="添加收藏"
              class="collect_icon"
            ></i>
            <!---->
          </div>
        </div>
        <div style="display: block;">
          <!---->

          <div class="remark"><span class="remark_title">备注：</span>
            <p class="remark_value">{{remark}}</p>
          </div>

          <div class="t_info_box"><span>{{polycurveDescription}}</span></div>

        </div>
      </div>
      <!---->
    </div>

  </div>

</template>

<script>
import { DrawGeometry, DrawGeometryType } from "../../model/DrawGeometryJs";
export default {
  name: "DrawPolycurveOverlay",
  data() {
    return {
      //当前
      curDrawItem: new DrawGeometry(),

      titleName: null,

      polycurveDescription: null,

      /**
       * 标记
       */
      remark: null,

      //收藏状态
      collectStatus: false
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init() {
      if (!this.curDrawItem) {
        this.curDrawItem = new DrawGeometry();
      }

      this.remark = this.curDrawItem.remark;

      let itemType = this.curDrawItem.type;

      if (itemType === DrawGeometryType.polyline) {
        this.titleName = "线标注";
        let lineLength = this.curDrawItem.getLength();
        if (lineLength > 1000) {
          this.polycurveDescription =
            "总长度为：" + (lineLength / 1000.0).toFixed(3) + "千米";
        } else {
          this.polycurveDescription =
            "总长度为：" + lineLength.toFixed(1) + "米";
        }
      } else if (itemType === DrawGeometryType.polygon) {
        this.titleName = "面标注";

        let pynArea = this.curDrawItem.getArea();
        if (pynArea > 1000000) {
          this.polycurveDescription =
            "总面积为：" + (pynArea / 1000000).toFixed(3) + "平方千米";
        } else {
          this.polycurveDescription =
            "总面积为：" + pynArea.toFixed(1) + "平方米";
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-weight: 700;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  padding: 5px 0;
}

.add_collect_box {
  position: relative;
  width: 14px;
  height: 14px;
  // display: inline-block;
  margin-right: 20px;
  float: right;
}

.collect_icon {
  background: url("../../../../assets/onlineMap/icon.png");
  background-position: -99px -155px;
  width: 17px;
  height: 16px;
  display: inline-block;
  cursor: pointer;
}

.remark {
  font-size: 12px;
  margin-top: 10px;
  // float: left;
  // width: 40px;
}

.remark_title {
  margin-left: 10px;
  float: left;
  width: 40px;
}

.remark_value {
  margin: 0;
  word-break: break-all;
}

.t_info_box {
  background: #f2f2f2;
  line-height: 30px;
  padding: 0 10px;
  margin-top: 10px;
  font-size: 12px;
  font-weight: 700;
}
</style>